import type { QuestionTypeOption } from './DynamicDTOs';

export const DynamicQuizOptionsG3: QuestionTypeOption[] = [
    {
        id: 3001,
        standards: ['test_3.NBT.4'],
        variants: [
            {
                id: 1,
                name: 'test_Comparing - Standard to Standard',
                route: 'numberCompare',
                params: {
                    leftMin: 1,
                    leftMax: 999,
                    leftDisplayModes: [1],
                    rightMin: 1,
                    rightMax: 999,
                    rightDisplayModes: [1],
                },
            },
            {
                id: 2,
                name: 'test_Comparing - Standard to Expanded',
                route: 'numberCompare',
                params: {
                    leftMin: 1,
                    leftMax: 999,
                    leftDisplayModes: [1],
                    rightMin: 1,
                    rightMax: 999,
                    rightDisplayModes: [2],
                },
            },
        ],
    },
];
